







































import { Component, Inject, Vue } from 'vue-property-decorator'
import { cloneDeep } from 'lodash'
import { Company } from '@/api/model/company'
import { WidgetAction } from '@/embed/widget/actions'
import { WidgetFlowType } from '@/api/types'

@Component
export default class EmmaUrls extends Vue {

    @Inject() readonly reloadCompany: () => Promise<void>
    company: Company = null
    loading: boolean = false

    async created() {
        await this.reload()
    }

    async reload(): Promise<void> {
        this.loading = true
        this.company = cloneDeep<Company>(this.$currentCompany)
        this.loading = false
    }

    get widgetUrl(): string {
        return process.env.VUE_APP_KEYVUE_WIDGET_BASEURL
    }

    get enabledWidgetFlowActions(): string[] {
        return Object.values(WidgetAction).filter(value => {
            return !Object.values(WidgetFlowType).includes(value as string as WidgetFlowType) || this.company.activatedWidgetFlowTypes.includes(value as string as WidgetFlowType)
        }) as string[]
    }
}
